import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { getProjects } from '../api/projects';
import Navbar from '../components/Navbar';
import ProjectCard from '../components/ProjectCard';
import '../styles/ICOListing.css';

export default function Home() {
  const navigate = useNavigate();
  const [recent, setRecent]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getProjects({ sort: 'recent' }).then(data => {
      setRecent(Array.isArray(data) ? data.slice(0, 3) : []);
      setLoading(false);
    });
  }, []);

  return (
    <div className="app-wrap">
<Helmet>
    <title>OnlineICO | ICO & IDO Presales Crypto — Earn Quests Rewards</title>
    <meta name="description" content="Discover the best ICO, IDO and crypto presales. Vote for projects, earn token rewards by completing quests, or launch your token with Token Studio." />
    <link rel="canonical" href="https://onlineico.com/" />

    <meta name="keywords" content="ICO, IDO, crypto presale, token sale, blockchain, crypto launchpad, DeFi, NFT, GameFi, crypto investment, token launch, crypto quests, earn crypto, new crypto projects, upcoming ICO, upcoming IDO, best crypto presale, early stage crypto, whitelist crypto, airdrop crypto, token creation, smart contract, ERC-20, BEP-20, Solana presale, Ethereum presale, BNB presale"/>
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="OnlineICO" />
    <meta property="og:title" content="OnlineICO | ICO & IDO Presales Crypto — Earn Quests Rewards" />
    <meta property="og:description" content="Discover the best ICO, IDO and crypto presales. Vote for projects, earn token rewards by completing quests, or launch your token with Token Studio." />
    <meta property="og:url" content="https://onlineico.com/" />
    <meta property="og:image" content="https://onlineico.com/og-image.png" />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />

    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content="@online_ico" />
    <meta name="twitter:title" content="OnlineICO | ICO & IDO Presales Crypto — Earn Quests Rewards" />
    <meta name="twitter:description" content="Discover the best ICO, IDO and crypto presales. Vote for projects, earn token rewards by completing quests, or launch your token with Token Studio." />
    <meta name="twitter:image" content="https://onlineico.com/og-image.png" />

<script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "OnlineICO",
        "url": "https://onlineico.com",
        "description": "Discover the best ICO, IDO and crypto presales. Vote for projects, earn token rewards by completing quests, or launch your token with Token Studio.",
        "publisher": {
            "@type": "Organization",
            "name": "OnlineICO",
            "url": "https://onlineico.com",
            "logo": "https://onlineico.com/logo_onlineico_v.png"
        },
        "potentialAction": {
            "@type": "SearchAction",
            "target": {
                "@type": "EntryPoint",
                "urlTemplate": "https://onlineico.com/ico/{search_term_string}"
            },
            "query-input": "required name=search_term_string"
        }
    })}</script>

</Helmet>
      <Navbar />

      {/* ── HERO ── */}
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '5rem 1.5rem 3rem', textAlign: 'center' }}>
        <div style={{ display: 'inline-block', background: 'rgba(52,211,153,0.1)', border: '1px solid rgba(52,211,153,0.25)', borderRadius: '30px', padding: '4px 16px', fontSize: '0.78rem', color: '#34D399', fontWeight: '600', marginBottom: '24px', letterSpacing: '1px', textTransform: 'uppercase' }}>
          🚀 The crypto launch platform
        </div>
        <h1 style={{ fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: 'clamp(2rem, 3vw, 2.5rem)', color: '#F1F5F9', lineHeight: 1.15, marginBottom: '20px' }}>
           Crypto presale <br />
          <span style={{ background: 'linear-gradient(135deg, #34D399, #3B82F6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
           Projects & Quests.
          </span>
        </h1>
        <p style={{ color: '#94a3b8', fontSize: '1.05rem', lineHeight: '1.8', maxWidth: '600px', margin: '0 auto 36px' }}>
          OnlineICO brings together the essentials in one place.
        </p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button className="vote-btn" style={{ padding: '12px 28px', fontSize: '1rem' }} onClick={() => navigate('/listings')}>
            Explore projects →
          </button>
          <button onClick={() => navigate('/add-crypto-project-ico')} style={{ padding: '12px 28px', fontSize: '1rem', borderRadius: '30px', border: '1px solid rgba(255,255,255,0.15)', background: 'transparent', color: '#94a3b8', cursor: 'pointer', fontFamily: 'Inter, sans-serif', fontWeight: '600' }}>
            + Submit my project
          </button>
        </div>
      </div>



     

      {/* ── DERNIERS PROJETS ── */}
      <div style={{ maxWidth: '1100px', margin: '0 auto 4rem', padding: '0 1.5rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div>
            <div style={{ fontSize: '0.72rem', color: '#34D399', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '6px' }}>Listings</div>
            <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '1.5rem', color: '#F1F5F9', margin: 0 }}>Latest listed projects</h2>
          </div>
          <button onClick={() => navigate('/listings')} style={{ background: 'none', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '12px', color: '#94a3b8', padding: '8px 16px', cursor: 'pointer', fontSize: '0.82rem', fontFamily: 'Inter, sans-serif' }}>
            View all →
          </button>
        </div>
        {loading ? (
          <div style={{ textAlign: 'center', color: '#64748b', padding: '2rem' }}>Loading...</div>
        ) : (
          <div className="featured-cards">
            {recent.map(p => <ProjectCard key={p.id} project={p} />)}
          </div>
        )}
      </div>

      {/* ── SERVICES ── */}
      <div style={{ maxWidth: '1100px', margin: '0 auto 4rem', padding: '0 1.5rem' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontSize: '0.72rem', color: '#8B5CF6', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '6px' }}>Our services</div>
          <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '1.5rem', color: '#F1F5F9', margin: 0 }}>Everything you need</h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>

          {/* LISTINGS */}
          <div onClick={() => navigate('/listings')} style={{ background: 'rgba(10,15,30,0.6)', border: '1px solid rgba(52,211,153,0.2)', borderRadius: '24px', padding: '28px', cursor: 'pointer', transition: 'all 0.2s', backdropFilter: 'blur(20px)' }}
            onMouseEnter={e => e.currentTarget.style.borderColor = 'rgba(52,211,153,0.5)'}
            onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(52,211,153,0.2)'}>
            <div style={{ fontSize: '2rem', marginBottom: '14px' }}>🚀</div>
            <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '1.1rem', color: '#F1F5F9', marginBottom: '10px' }}>ICO / IDO Listings</div>
            <p style={{ color: '#94a3b8', fontSize: '0.88rem', lineHeight: '1.7', margin: '0 0 16px' }}>
              Discover and vote for the best crypto projects. Filter by status, trending or recent.
            </p>
            <span style={{ color: '#34D399', fontSize: '0.82rem', fontWeight: '600' }}>Explore →</span>
          </div>

          {/* EARN */}
          <div onClick={() => navigate('/earn')} style={{ background: 'rgba(10,15,30,0.6)', border: '1px solid rgba(245,158,11,0.2)', borderRadius: '24px', padding: '28px', cursor: 'pointer', transition: 'all 0.2s', backdropFilter: 'blur(20px)' }}
            onMouseEnter={e => e.currentTarget.style.borderColor = 'rgba(245,158,11,0.5)'}
            onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(245,158,11,0.2)'}>
            <div style={{ fontSize: '2rem', marginBottom: '14px' }}>⚡</div>
            <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '1.1rem', color: '#F1F5F9', marginBottom: '10px' }}>Earn — Quests</div>
            <p style={{ color: '#94a3b8', fontSize: '0.88rem', lineHeight: '1.7', margin: '0 0 16px' }}>
              Complete quests linked to listed projects and earn rewards.
            </p>
            <span style={{ color: '#F59E0B', fontSize: '0.82rem', fontWeight: '600' }}>View quests →</span>
          </div>

          {/* TOKEN STUDIO */}
          <div onClick={() => navigate('/token-studio')} style={{ background: 'rgba(10,15,30,0.6)', border: '1px solid rgba(139,92,246,0.2)', borderRadius: '24px', padding: '28px', cursor: 'pointer', transition: 'all 0.2s', backdropFilter: 'blur(20px)' }}
            onMouseEnter={e => e.currentTarget.style.borderColor = 'rgba(139,92,246,0.5)'}
            onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(139,92,246,0.2)'}>
            <div style={{ fontSize: '2rem', marginBottom: '14px' }}>🛠️</div>
            <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '1.1rem', color: '#F1F5F9', marginBottom: '10px' }}>Token Studio</div>
            <p style={{ color: '#94a3b8', fontSize: '0.88rem', lineHeight: '1.7', margin: '0 0 16px' }}>
              Token creation, smart contract, ICO/IDO launch support. Experts by your side.
            </p>
            <span style={{ color: '#8B5CF6', fontSize: '0.82rem', fontWeight: '600' }}>Discover →</span>
          </div>

        </div>
      </div>

      {/* ── CTA FINAL ── */}
      <div style={{ maxWidth: '700px', margin: '0 auto 6rem', padding: '0 1.5rem', textAlign: 'center' }}>
        <div style={{ background: 'linear-gradient(135deg, rgba(52,211,153,0.08), rgba(59,130,246,0.08))', border: '1px solid rgba(52,211,153,0.2)', borderRadius: '28px', padding: '48px 32px' }}>
          <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: '1.8rem', color: '#F1F5F9', marginBottom: '14px' }}>Ready to launch your project?</h2>
          <p style={{ color: '#94a3b8', fontSize: '0.95rem', lineHeight: '1.8', marginBottom: '28px' }}>
            Submit your ICO or IDO in minutes and gain visibility among thousands of investors.
          </p>
          <button className="vote-btn" style={{ padding: '14px 32px', fontSize: '1rem' }} onClick={() => navigate('/add-crypto-project-ico')}>
            🚀 Submit my project
          </button>
        </div>
      </div>

    </div>
  );
}
